import React, { useCallback, useMemo, useState } from 'react'
import { User, UserRole } from '@/types'
import { ActorUsersPage } from '@/components/users/ActorUsersPage'
import { ActorApkModal } from '@/components/apk/ActorApkModal'
import { createApkColumn } from '@/components/apk/createApkColumn'
import { useResellersStore } from '@/stores/resellers.store'
import { useAuth } from '@/hooks/useAuth'
import { canManageApk, canManageResellers } from '@/utils/role-access'

export const ResellersPage: React.FC = () => {
  const resellers = useResellersStore(state => state.resellers)
  const fetchResellers = useResellersStore(state => state.fetchResellers)
  const addReseller = useResellersStore(state => state.addReseller)
  const updateReseller = useResellersStore(state => state.updateReseller)
  const deleteReseller = useResellersStore(state => state.deleteReseller)
  const { user } = useAuth()
  const [apkActor, setApkActor] = useState<User | null>(null)

  const handleApkClick = useCallback((actor: User) => {
    setApkActor(actor)
  }, [])

  const apkColumn = useMemo(() => createApkColumn(handleApkClick), [handleApkClick])

  return (
    <>
    <ActorUsersPage
      title="Liste des revendeurs directs"
      createButtonLabel="Nouveau revendeur"
      gridCollection="resellers"
      users={resellers}
      fetchUsers={fetchResellers}
      onCreate={data => addReseller({ ...data, role: UserRole.RESELLER })}
      onUpdate={updateReseller}
      onDelete={deleteReseller}
      canManage={canManageResellers(user)}
      fixedRole={UserRole.RESELLER}
      hideRoleColumn
      createTitle="Nouveau revendeur direct"
      editTitle="Modifier le revendeur"
      autoGeneratePassword
      requireBillingFields
      showBrandingFields
      showActorColumns
      showLoginAs={true}
      extraColumns={[apkColumn]}
    />

    {apkActor && (
      <ActorApkModal
        actor={apkActor}
        canManage={canManageApk(user)}
        onClose={() => setApkActor(null)}
      />
    )}
    </>
  )
}
